










import { IPost } from "@/types/post.model";
import { PropType } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import PostListItem from "./PostListItem.vue";

@Component({
  components: {
    PostListItem,
  },
})
export default class MultiPostListItem extends Vue {
  @Prop({ type: Array as PropType<IPost[]>, required: true }) posts!: IPost[];
  @Prop({ required: false, type: Boolean, default: false })
  isCurrentActorMember!: boolean;
}
